{
  "_comment": "[CI-LOCKED] תוכן קובץ זה נעול. תרומות יתקבלו בברכה, אך אימות השינויים עשוי להתעכב.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "תוכנית ה- Bot‏ $1 אמרה:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "סוכן",
  "ACTIVITY_YOU_SAID_ALT": "אמרת:",
  "ACTIVITY_BOT_ATTACHED_ALT": "תוכנית Bot צירפה:",
  "ACTIVITY_CODE_ALT": "דוגמת קוד: $1",
  "ACTIVITY_CONTENT_CAUTION": "תוכן שנוצר באמצעות בינה מלאכותית עשוי להיות שגוי",
  "ACTIVITY_CODE_CAUTION": "קוד שנוצר בינה מלאכותית. יש לבדוק ולהשתמש בזהירות",
  "ACTIVITY_ERROR_BOX_TITLE": "הודעת שגיאה",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "לחץ כדי לקיים אינטראקציה.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "ההודעה היא אינטראקטיבית.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "יש קישור אחד או יותר בהודעה.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "השליחה נכשלה.",
  "ACTIVITY_YOU_ATTACHED_ALT": "צירפת:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "קובץ מצורף אחד.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 קבצים מצורפים.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 קבצים מצורפים.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 קבצים מצורפים.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 קבצים מצורפים.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "השליחה נכשלה. [נסה שנית][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "שולח",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "נשלח בשעה $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "ממש עכשיו",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "לפני שעה",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "לפני דקה",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "היום",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "אתמול",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "שגיאה בניתוח מבנה טקסט של כרטיס מסתגל",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "שגיאה בעיבוד כרטיס מסתגל",
  "ATTACHMENT_AUDIO": "קליפ שמע.",
  "ATTACHMENT_CARD": "כרטיס: $1 $2 $3",
  "ATTACHMENT_FILE": "קובץ: $1",
  "ATTACHMENT_IMAGE": "תמונה",
  "ATTACHMENT_TEXT": "טקסט: $1",
  "ATTACHMENT_VIDEO": "קליפ וידאו",
  "AVATAR_ALT": "אוואטאר $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "הבא",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "הקודם",
  "CITATION_MODEL_DIALOG_ALT": "ציטוט",
  "CLOSE_BUTTON_ALT": "לסגור",
  "COLLAPSIBLE_GROUPING_TITLE": "חושב…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "זה מוצג כאשר הבוט מרכיב הודעות תגובה בקבוצה אם לא סופק תקציר.",
  "COLLAPSE_BUTTON_LESS": "הצג פחות",
  "COLLAPSE_BUTTON_LESS.comment": "זהו הטקסט של לחצן סוגר זוויתי כדי לכווץ קבוצת הודעות. כאשר משתמש הקצה לוחץ על הכפתור, קבוצת ההודעות מתקפלת.",
  "COLLAPSE_BUTTON_MORE": "הצג עוד",
  "COLLAPSE_BUTTON_MORE.comment": "זהו הטקסט של לחצן זוויתי להרחבת קבוצת הודעות. כאשר משתמש הקצה לוחץ על הכפתור, קבוצת ההודעות מתרחבת.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "מחובר",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "מתחבר...",
  "CONNECTIVITY_STATUS_ALT_FATAL": "לא ניתן להתחבר.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "אירעה הפרעה ברשת. מתחבר מחדש...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "שגיאת עיבוד. בדוק את המסוף או פנה אל מפתח הבוט.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "ההתחברות נמשכת זמן רב מהרגיל.",
  "CONNECTIVITY_STATUS_ALT": "מצב קישוריות: $1",
  "COPY_BUTTON_TEXT": "להעתיק",
  "COPY_BUTTON_COPIED_TEXT": "הועתק",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "שליחה",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "ביטול",
  "FEEDBACK_FORM_PLACEHOLDER": "יש לספק פרטים רבים ככל האפשר, אך אין לכלול מידע פרטי או רגיש.",
  "FEEDBACK_FORM_TITLE": "רוצה לספר לנו על החוויה שלך?",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "הורד את הקובץ '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "הורד את הקובץ '$1' בגודל $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "‏'$1' בגודל $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "נפתח בחלון חדש; חיצוני.",
  "RECEIPT_CARD_TAX": "מס",
  "RECEIPT_CARD_TOTAL": "סך הכל",
  "RECEIPT_CARD_VAT": "מע\"מ",
  "REFERENCE_LIST_HEADER_ONE": "הפניית $1",
  "REFERENCE_LIST_HEADER_FEW": "הפניות $1",
  "REFERENCE_LIST_HEADER_MANY": "הפניות $1",
  "REFERENCE_LIST_HEADER_OTHER": "הפניות $1",
  "REFERENCE_LIST_HEADER_TWO": "הפניות $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "מחיקת קובץ מצורף $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "מחיקה",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "קובץ",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "תמונה",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "לא ניתן לשלוח הודעה ריקה.",
  "SPEECH_INPUT_LISTENING": "מאזין…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "כבה מיקרופון",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "הפעל מיקרופון",
  "SPEECH_INPUT_STARTING": "מתחיל...",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "הבא",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "הקודם",
  "SUGGESTED_ACTIONS_LABEL_ALT": "פעולות מוצעות",
  "TEXT_INPUT_ALT": "תיבה להזנת הודעה",
  "TEXT_INPUT_PLACEHOLDER": "הקלד את ההודעה שלך",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "התחל לדבר...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "מאזין...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "מעבד...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "דבר כדי לקטוע...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "שלח",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "דבר",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "העלה קובץ",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "לוח חיוג",
  "TEXT_INPUT_DROP_ZONE": "שחרור קבצים",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "חריגה ממגבלת אורך ההודעה",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "תומך בקלט בן ספרה אחת בלבד",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 קבצים מצורפים",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 קבצים מצורפים",
  "TEXT_INPUT_ATTACHMENTS_ONE": "קובץ מצורף 1",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 קבצים מצורפים",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 קבצים מצורפים",
  "TOAST_ACCORDION_FEW": "$1 הודעות: לחץ כאן להצגת פרטים",
  "TOAST_ACCORDION_MANY": "$1 הודעות: לחץ כאן להצגת פרטים",
  "TOAST_ACCORDION_OTHER": "$1 הודעות: לחץ כאן להצגת פרטים",
  "TOAST_ACCORDION_TWO": "$1 הודעות: לחץ כאן להצגת פרטים",
  "TOAST_ALT_ERROR": "‏‏שגיאה",
  "TOAST_ALT_INFO": "מידע",
  "TOAST_ALT_SUCCESS": "הצלחה",
  "TOAST_ALT_WARN": "אזהרה",
  "TOAST_DISMISS_BUTTON": "בטל",
  "TOAST_TITLE_ALT": "הודעה",
  "TRANSCRIPT_ARIA_LABEL_ALT": "היסטוריית צ'אט, הקש על מקשי החצים כדי לנווט.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "היסטוריית צ'אט",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "ההודעה היא אינטראקטיבית. הקש על המקשים Shift ו- Tab פעמיים עד שלוש פעמים כדי לעבור להיסטוריית הצ'אט. לאחר מכן לחץ על ההודעה כדי ליצור אינטראקציה.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "יש קישור אחד או יותר בהודעה. הקש על המקשים Shift ו- Tab פעמיים עד שלוש פעמים כדי לעבור להיסטוריית הצ'אט. לאחר מכן לחץ על ההודעה כדי ליצור אינטראקציה.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "ההודעה כוללת פעולות מוצעות. הקש Shift Tab פעמיים או שלוש פעמים כדי לבחור אותן.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "ההודעה כוללת פעולות מוצעות. הקש $1 כדי לבחור אותן.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "שליחת ההודעה נכשלה.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "הודעות חדשות זמינות. יש ללחוץ על $1 כדי למקד את הלחצן $2.",
  "TRANSCRIPT_MORE_MESSAGES": "הודעות נוספות",
  "TRANSCRIPT_NEW_MESSAGES": "הודעות חדשות",
  "TRANSCRIPT_TERMINATOR_TEXT": "סוף היסטוריית הצ'אט",
  "TYPING_INDICATOR_ALT": "מחוון שמציג הקלדה",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 מקליד/ה.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 ואחרים מקלידים/ות.",
  "VIEW_CODE_BUTTON_TEXT": "קוד",
  "VOTE_COMPLETE_ALT": "המשוב נרשם",
  "VOTE_COMPLETE_ALT.comment": "אפשרות זו מיועדת לקורא מסך. תווית של לחצן עם סמלי אגודל למעלה/למטה. השימוש בתווית נעשה כאשר המשוב נרשם.",
  "VOTE_DISLIKE_ALT": "לא אהבתי",
  "VOTE_LIKE_ALT": "אהבתי"
}